import { Injectable } from '@angular/core';
import { AppConfigFindInterface } from '@zaoblako/shared/modules/system/dtos/app-config-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BasisSystemAppMetadataService extends BaseService {
  protected baseUrl = '/basis/system/app-metadata';

  public getConfig(): Observable<AppConfigFindInterface> {
    return this.http.get<AppConfigFindInterface>(`${this.baseUrl}/config`);
  }
}
